import { useTranslation } from "react-i18next";
import { SettingsSection } from "./settingSection.component";
import { NumberSettingInput } from "./numberSettingInput.component";

export const BreakSetting: React.FC<{
  value: number;
  onChange: (v: number) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <SettingsSection title={t("System.Break")} info={t("System.BreakInfo")}>
      <NumberSettingInput
        label={t("System.Break")}
        value={value}
        onChange={onChange}
      />
    </SettingsSection>
  );
};